export default __webpack_public_path__ + "static/media/Apple_Music.c65da438.svg";